import {Component, inject} from '@angular/core';
import {RouterOutlet, RouterModule} from '@angular/router';
import {MaterialModule} from '@app/material.module';
import {CommonModule} from '@angular/common';
import {CoreService} from '@services/core.service';
import {AppSettings} from '@app/config';
import {TranslateModule} from '@ngx-translate/core';
import {MessagesComponent} from '@components/messages/messages.component';

@Component({
  selector: 'app-auth-layout',
  imports: [RouterOutlet, MaterialModule, CommonModule, RouterModule, TranslateModule, MessagesComponent],
  standalone: true,
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss'
})
export class AuthLayoutComponent {
  private htmlElement!: HTMLHtmlElement;
  private settings = inject(CoreService);

  options = this.settings.getOptions();

  constructor() {
    this.htmlElement = document.querySelector('html')!;
    // Initialize project theme with options
    this.receiveOptions(this.options);
  }

  receiveOptions(options: AppSettings): void {
    this.toggleDarkTheme(options);
    this.toggleColorsTheme(options);
  }

  toggleDarkTheme(options: AppSettings) {
    if (options.theme === 'dark') {
      this.htmlElement.classList.add('dark-theme');
      this.htmlElement.classList.remove('light-theme');
    } else {
      this.htmlElement.classList.remove('dark-theme');
      this.htmlElement.classList.add('light-theme');
    }
  }

  toggleColorsTheme(options: AppSettings) {
    // Remove any existing theme class dynamically
    this.htmlElement.classList.forEach((className) => {
      if (className.endsWith('_theme')) {
        this.htmlElement.classList.remove(className);
      }
    });

    // Add the selected theme class
    this.htmlElement.classList.add(options.activeTheme);
  }
}